import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles/global.css";
// Importing the theme module triggers its top-level applyTheme() call,
// setting <html data-theme="..."> from localStorage before React renders.
// This avoids a flash of light theme on dark-mode reloads.
import "./lib/theme";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
